import { mediaQuery } from 'constants/ui';

export const titleWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: '240px 1fr auto',
  alignItems: 'center',
  padding: '20px 0',

  [mediaQuery.mobileAndTablet]: {
    gridTemplateColumns: '1fr',
    gap: '12px',
    padding: '16px 0',
  },
};

export const titleStyles = {
  paddingLeft: '24px',

  [mediaQuery.mobileAndTablet]: {
    paddingLeft: '16px',
  },
};

export const propertySummaryCardsWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, auto)',
  gap: '16px',

  [mediaQuery.mobileAndTablet]: {
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
  },
};

export const propertySummaryCardStyles = {
  padding: '4px 8px',
};
